import React from "react";
import ReactDOM from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { registerSW } from "virtual:pwa-register";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- Service worker registration + auto-update ------------------------------
// Web only. Native (Capacitor) builds serve their assets from the app bundle
// and update through the app stores; they use @capacitor/push-notifications
// rather than the web-push service worker, so a SW has nothing to do there.
//
// registerType is "autoUpdate" (vite.config.js). Because the worker skips
// waiting + claims clients on install (src/sw.ts), virtual:pwa-register reloads
// the page exactly once as soon as the new worker takes control — so a new
// deploy is picked up automatically instead of needing several hard refreshes.
// It does NOT reload on the first install, only on genuine updates.
//
// onRegisteredSW then re-checks for a newer build hourly and whenever the tab
// regains focus, so a long-lived standalone PWA session updates without the
// user having to navigate.
if (!Capacitor.isNativePlatform()) {
  registerSW({
    immediate: true,
    onRegisteredSW(_swScriptUrl, registration) {
      if (!registration) return;
      const checkForUpdate = () => {
        // Swallow transient/offline failures; the next tick retries.
        registration.update().catch(() => undefined);
      };
      setInterval(checkForUpdate, 60 * 60 * 1000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") checkForUpdate();
      });
    },
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
